import { isEmpty } from "lodash";
import { z } from "zod";

export const AddTrainingSchema = z.object({
  integrationCourse: z
    .object({
      id: z.string(),
      name: z.string()
    })
    .nullable()
    .refine((data) => !isEmpty(data) && !!data.id, {
      message: "Training is required"
    }),
  integration: z
    .object({
      id: z.string(),
      name: z.string()
    })
    .optional()
    .nullable(),
  completionDate: z
    .string()
    .min(1, "Completion date is required")
    .optional()
    .refine((data) => !isEmpty(data), {
      message: "Completion date is required"
    }),
  state: z.string().optional(),
  commentText: z.string().optional(),
  formFiles: z.any()
});
export const AddEmployeeTrainingSchema = z.object({
  integrationCourse: z
    .object({
      id: z.string(),
      name: z.string()
    })
    .optional()
    .nullable()
    .refine((data) => !isEmpty(data), {
      message: "Training is required"
    }),
  completionDate: z
    .string()
    .min(1, "Completion date is required")
    .optional()
    .refine((data) => !isEmpty(data), {
      message: "Completion date is required"
    }),
  state: z.string().optional(),
  commentText: z.string().optional(),
  formFiles: z.any()
});

export const CreateTrainingSchema = z.object({
  trainingName: z
    .string()
    .min(2, "Please enter a valid name (between 2 and 300 characters)")
    .max(300, "Please enter a valid name (less than 300 characters)"),
  requiredFaculties: z.string().optional(),
  recurrence: z
    .object({
      value: z.number()
    })
    .optional(),
  selectedCompetencies: z.array(z.any()).default([]),
  selectedIntegrationId: z
    .object({
      id: z.string(),
      name: z.string()
    })
    .nullable()
    .optional()
    .refine((val) => val !== null && val !== undefined && val.name !== "", {
      message: "Integration is required"
    })
});
